import { useState } from "react";
import { teammatesApi } from "../api";
import { useConfirm } from "./useConfirm";
import { notifyTeammatesUpdated } from "./useTeammates";
import type { Teammate } from "../types/teammates";

export function useTeammateActions() {
  const { confirm, confirmDialog } = useConfirm();
  const [joiningId, setJoiningId] = useState<string | null>(null);

  function join(teammate: Teammate) {
    setJoiningId(teammate.id);
    teammatesApi.join(teammate.id)
      .then(notifyTeammatesUpdated)
      .catch(() => {})
      .finally(() => setJoiningId(null));
  }

  async function leave(teammate: Teammate) {
    const ok = await confirm({
      title: `Remove ${teammate.name} from your team?`,
      message: `Your chats with ${teammate.name} stay under All chats. You can add ${teammate.name} back from the Marketplace.`,
      confirmLabel: "Remove",
    });
    if (!ok) return;
    teammatesApi.leave(teammate.id).then(notifyTeammatesUpdated).catch(() => {});
  }

  async function remove(teammate: Teammate): Promise<boolean> {
    const ok = await confirm({
      title: `Delete ${teammate.name}?`,
      message: `${teammate.name} is removed for everyone who added it. Existing chats with ${teammate.name} become normal Brian chats.`,
      confirmLabel: "Delete",
      danger: true,
    });
    if (!ok) return false;
    try {
      await teammatesApi.remove(teammate.id);
      notifyTeammatesUpdated();
      return true;
    } catch {
      return false;
    }
  }

  return { join, leave, remove, joiningId, confirmDialog };
}
